// Theme interactions. Cart requests use Shopify's same-store cart endpoint only.
function initPantry(root = document) {
  root.querySelectorAll('[data-pd-collections]').forEach(group => {
    if (group.dataset.ready) return;
    group.dataset.ready = 'true';
    const tabs = [...group.querySelectorAll('[role="tab"]')];
    const panels = [...group.querySelectorAll('[role="tabpanel"]')];
    const select = (index, focus = false) => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        tab.classList.toggle('is-active', i === index);
        panels[i].hidden = i !== index;
      });
      if (focus) tabs[index].focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', event => {
        const next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : null;
        if (next !== null) { event.preventDefault(); select(next, true); }
      });
    });
  });
  root.querySelectorAll('[data-pd-slideshow]').forEach(group => {
    if (group.dataset.ready) return;
    group.dataset.ready = 'true';
    const slides = [...group.querySelectorAll('.interior-gallery__slide')];
    if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let active = 0;
    window.setInterval(() => {
      slides[active].classList.remove('is-active');
      active = (active + 1) % slides.length;
      slides[active].classList.add('is-active');
    }, 5500);
  });
  root.querySelectorAll('[data-pd-review-carousel]').forEach(group => {
    if (group.dataset.ready) return;
    group.dataset.ready = 'true';
    const reviews = [...group.querySelectorAll('.recent-review')];
    const dots = [...group.querySelectorAll('.recent-reviews__dots span')];
    if (reviews.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let active = 0;
    window.setInterval(() => {
      reviews[active].classList.remove('is-active');
      dots[active]?.classList.remove('is-active');
      active = (active + 1) % reviews.length;
      reviews[active].classList.add('is-active');
      dots[active]?.classList.add('is-active');
    }, 6000);
  });
}
initPantry();
document.addEventListener('shopify:section:load', event => initPantry(event.target));
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.pd-mobile-nav[open]').forEach(menu => {menu.open = false; menu.querySelector('summary').focus();});
});
